import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectGuard implements CanActivate {
  
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    // Szinkron ellenőrzés - azonnal döntést hozunk
    if (this.authService.isAuthenticated()) {
      // Ha be vagyunk jelentkezve, irányítsunk át az overview oldalra
      this.router.navigate(['/overview']);
      return false; // Ne jelenítse meg a login oldalt
    } else {
      // Ha nincs bejelentkezve, mutassa a login oldalt
      return true;
    }
  }
}
